<template>
<div v-if="show">
    <ul class="calendar-top wrap">
        <li class="pointer" @click="set_cal_pre()"><img src="../assets/img/arrow-left.png" alt=""></li>
        <li class="pointer">
            <!-- <h4 class="bold" >2020년 5월</h4> -->
            <h4 class="bold" v-text=" cal_year + '년 ' + cal_month_str "></h4>
        </li>
        <li class="pointer" @click="set_cal_next()"><img src="../assets/img/arrow-right.png" alt=""></li>
    </ul>
    <div >
        <div v-if="lang=='EN'">
            <div class="none-ev" v-if="eval_plan.ev.s_comment == '' && eval_plan.ev.t_comment == '' && eval_plan.ev.w_comment == ''">
                <p>작성된 EV가 없습니다.</p>
            </div>
            <div class="clear ev-info" v-else>
                <div class="ev-title-wrap">
                    <div class="ev-title"><span class="bold">{{ eval_plan.member_ename }}</span><span> Monthly Feedback</span></div>
                    <div class="cb ev-writer"><span class="fl bold">Evaluator : </span> <span class="fl">{{ eval_plan.tutor_ename }}</span></div>
                    <div class="cb ev-wdate" v-if="typeof eval_plan.ev.createdate != 'undefined'"><span>{{ eval_plan.ev.createdate }}</span></div>
                </div>
                <div class="ev-info-wrap">
                    <div class="info-title"><span class="ico-r">1</span> Learning Topic</div>
                    <div class="info-content preline">{{ eval_plan.ev.objective }}</div>
                    <div class="pt-50"></div>

                    <div class="info-title"><span class="ico-r">2</span> Language Competency</div>
                    <div class="info-content">
                        <div class="graph-bar-wrap">
                            <div class="graph-bar-head">
                                <div class="graph-bar-head-tit-fir"></div>
                                <div class="graph-bar-head-tit need">Need to<br>Improve</div>
                                <div class="graph-bar-head-tit fair">Fair</div>
                                <div class="graph-bar-head-tit good">Good</div>
                                <div class="graph-bar-head-tit very-good">Very Good</div>
                                <div class="graph-bar-head-tit exce-line">Exce-lient</div>
                            </div>
                            <div class="graph-bar-body">
                                <div class="graph-bar-body-list">
                                    <div class="graph-bar-body-item col-s1">
                                        <div class="graph-bar-tit">Pronunciation</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.pronunciation) }"></div>

                                    </div>
                                    <div class="graph-bar-body-item col-s2">
                                        <div class="graph-bar-tit">Comprehension</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.comprehension) }"></div>
                                    </div>
                                    <div class="graph-bar-body-item col-s3">
                                        <div class="graph-bar-tit">Accuracy</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.accuracy) }"></div>
                                    </div>
                                    <div class="graph-bar-body-item col-s4">
                                        <div class="graph-bar-tit">Fluency</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.fluency) }"></div>
                                    </div>
                                    <div class="graph-bar-body-item col-s5">
                                        <div class="graph-bar-tit">Participation</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.participation) }"></div>
                                    </div>
                                    <div class="graph-bar-body-item col-s5">
                                        <div class="graph-bar-tit">Preparation</div>
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.preparation) }"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fl chart-block">
                            <div id="chartdiv1" ref="chartdiv1" style="width:100%;height:280px;"></div>
                        </div>
                    </div>

                    <div class="info-title mt-30"><span class="ico-r">3</span> Overall Feedback</div>
                    <div class="clear">
                        <div class="info-content preline">
                            <div class="bold overall-title">Strong points</div>
                            <div class="overall-body">{{ eval_plan.ev.s_comment }}</div>
                        </div>
                        <div class="info-content preline">
                            <div class="bold overall-title">Weak points</div>
                            <div class="overall-body">{{ eval_plan.ev.w_comment }}</div>
                        </div>
                        <div class="info-content preline">
                            <div class="bold overall-title">Next action plans</div>
                            <div class="overall-body">{{ eval_plan.ev.t_comment }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="none-ev" v-if="eval_plan.ev.s_comment == '' && eval_plan.ev.t_comment == '' && eval_plan.ev.w_comment == ''">
                <p>작성된 EV가 없습니다.</p>
                </div>
            <div class="clear ev-info" v-else>
                <div class="ev-title-wrap">
                    <div class="ev-title"><span class="bold">{{ eval_plan.member_ename }}</span><span> Monthly Feedback</span></div>
                    <div class="cb ev-writer"><span class="fl bold">Evaluator : </span> <span class="fl">{{ eval_plan.tutor_ename }}</span></div>
                    <div class="cb ev-wdate" v-if="typeof eval_plan.ev.createdate != 'undefined'"><span>{{ eval_plan.ev.createdate }}</span></div>
                </div>
                <div class="ev-info-wrap">
                    <div class="info-title"><span class="ico-r">1</span> Learning Topic</div>
                    <div class="info-content preline">{{ eval_plan.ev.objective }}</div>
                    <div class="pt-50"></div>

                    <div class="info-title"><span class="ico-r">2</span> Language Competency</div>
                    <div class="info-content">
                        <div class="graph-bar-wrap">
                            <div class="graph-bar-head">
                                <div class="graph-bar-head-tit-fir"></div>
                                <div class="graph-bar-head-tit need">매우<br>노력 필요</div>
                                <div class="graph-bar-head-tit fair">노력 필요</div>
                                <div class="graph-bar-head-tit good">보통</div>
                                <div class="graph-bar-head-tit very-good">우수</div>
                                <div class="graph-bar-head-tit exce-line">매우 뛰어남</div>
                            </div>
                            <div class="graph-bar-body">
                                <div class="graph-bar-body-list">
                                    <div class="graph-bar-body-item col-s1">
                                        <div class="graph-bar-tit">발음</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.pronunciation) }"></div>

                                    </div>
                                    <div class="graph-bar-body-item col-s2">
                                        <div class="graph-bar-tit">이해도</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.comprehension) }"></div>
                                    </div>
                                    <div class="graph-bar-body-item col-s3">
                                        <div class="graph-bar-tit">정확성</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.accuracy) }"></div>
                                    </div>
                                    <div class="graph-bar-body-item col-s4">
                                        <div class="graph-bar-tit">유창성</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.fluency) }"></div>
                                    </div>
                                    <div class="graph-bar-body-item col-s5">
                                        <div class="graph-bar-tit">참여도</div>
                                        <!-- <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box on"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div>
                                <div class="graph-bar-box"></div> -->
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.participation) }"></div>
                                    </div>
                                    <div class="graph-bar-body-item col-s5">
                                        <div class="graph-bar-tit">준비성</div>
                                        <div class="graph-bar-box" v-for="(item,index) in 5" :key="index" :class="{ 'on':item*2<=(eval_plan.ev.preparation) }"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fl chart-block">
                            <div id="chartdiv1" ref="chartdiv1" style="width:100%;height:280px;"></div>
                        </div>
                    </div>

                    <div class="info-title"><span class="ico-r">3</span> Overall Feedback</div>
                    <div class="clear">
                        <div class="info-content preline">
                            <div class="bold overall-title">Strong points</div>
                            <div class="overall-body">{{ eval_plan.ev.s_comment }}</div>
                        </div>
                        <div class="info-content preline">
                            <div class="bold overall-title">Weak points</div>
                            <div class="overall-body">{{ eval_plan.ev.w_comment }}</div>
                        </div>
                        <div class="info-content preline">
                            <div class="bold overall-title">Next action plans</div>
                            <div class="overall-body">{{ eval_plan.ev.t_comment }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div>
        
        <div v-if="eval_plan.ev" class="eval-view">
            <div class="info" style="max-width: 600px;margin:auto;">
                <div class="b w100 fl">Name</div>
                <div class="info_txt fl">{{ eval_plan.member_kname }}</div>
                <div class="cb pt10"></div>
                <div class="b w100 fl">Evaluator</div>
                <div class="info_txt fl">{{ (eval_plan.tutor_ename?eval_plan.tutor_ename:"") + (eval_plan.tutor_kname?'(' + eval_plan.tutor_kname + ')':'') }}</div>
                <div class="cb pt10"></div>
                <div class="b w100 fl">Result</div>
                <div class="info_txt fl">{{ eval_plan.res_my + ' / ' + eval_plan.res_total }}</div>
                <div class="cb pt10"></div>
                <div class="b w100 fl">Level</div>
                <div class="info_txt fl">{{ eval_plan.level }}</div>
                <div class="progress-label">
                    <div class="progress-bar">
                        <span class="progress point-color-bg " v-bind:class="{ 'L1':eval_plan.level=='L1', 'L2':eval_plan.level=='L2', 'L3':eval_plan.level=='L3', 'L4':eval_plan.level=='L4', 'L5':eval_plan.level=='L5', 'L6':eval_plan.level=='L6', 'L7':eval_plan.level=='L7' }"></span>
                        <img src="/resource/itmstudent/img/in_class/bg_level_progress_579x19_trans.png" class="progress-mask level-progress">
                    </div>
                    <div class="progress-label-bottom">
                        <span>L1</span>
                        <span>L2</span>
                        <span>L3</span>
                        <span>L4</span>
                        <span>L5</span>
                        <span>L6</span>
                        <span>L7</span>
                    </div>
                </div>
                <div class="cb pt10"></div>
            </div>
            <div v-if="eval_plan.ev">
                <div class="info">
                    <div class="info_tit">Ⅰ. Language Competency</div>
                    <div class="cb pt10">
                        <div id="chartdiv1" class="textwidth100 h300" ref="chartdiv1"></div>
                    </div>
                </div>
                <div class="info" v-if="eval_plan.language=='EN'">
                    <div class="info_tit">Ⅱ. Class Effort</div>
                    <div class="cb pt10">
                        <div ref="chartdiv2" id="chartdiv2" class="textwidth100 h300" style="max-width:600px;margin:auto;"></div>
                    </div>
                </div>
                <div class="info">
                    <div class="info_tit">Overall Feedback</div>
                    <div class="cb pt10">
                        <span class="text" v-html="eval_plan.t_comment"></span>
                    </div>
                </div>
                <div class="info">
                    <div class="info_tit">Graph Ⅰ. Current Status</div>
                    <div class="cb pt10">
                        <div ref="chartdiv3" id="chartdiv3" class="textwidth100 h300" style="max-width:600px;margin:auto;"></div>
                    </div>
                </div>
                <div class="info">
                    <div class="info_tit">Graph II. Accumulative Recording</div>
                    <div class="cb pt10">
                        <div id="bchartdiv2" ref="bchartdiv2" class="textwidth100 h400"></div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

</div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
export default {
    name: 'EvReport',
    props: {
        visible: {
            type: Boolean,
            require: true,
            default: false
        },
        classid: {
            type: String,
            default: ""
        },
        cal_year: {
            type: Number,
            default: 0
        },
        cal_month: {
            type: Number,
            default: 0
        }
    },

    data: () => ({
        is_loader_pop: false,
        eval_plan: {},
        lang: "KO",
        ev_txt: {
            fluency_str: "유창성",
            accuracy_str: "정확성",
            pronunciation_str: "발음",
            comprehension_str: "이해도",
            participation_str: "참여도",
            preparation_str: "준비성"
        },

        cal_month_str: "",
        cal_days: [{
            txt: "1",
            style: ""
        }, {
            txt: "2",
            style: ""
        }],
        reportdate: "",
        show: false,
        chart1: null,
        chart2: null,
        chart3: null,
        chart4: null
    }),
    watch: {
        show: function (newVal) {
            if (newVal == true) {
                 if(location.hostname == "stagest.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                }else if(location.hostname == "st.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }else if(location.hostname == "student.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }else if(location.hostname == "m.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }else if(location.href.includes("how")){
                    if(location.href.includes("stage")){
                        this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                    }else{
                        this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                    }
                }else{
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }
            this.reportdate = this.cal_year + "-" + this.cal_month;
            
                this.getEvaluation();
            } else {
                console.log("else");
            }
        }
    },
    mounted() {
        // console.log(this.cal_month);
        // console.log(this.manager_email+"/");
        // var today = new Date();

        //  this.cal_year = today.getFullYear();
        // this.cal_month = today.getMonth() + 1;
        // this.getEvaluation();
        // console.log(this.show);
        // this.show = false;
        // console.log(this.visible);
        this.show = this.visible;
        // console.log(this.show);
    },

    methods: {

        set_cal_pre: function () {
            this.cal_month = this.cal_month - 1;
            if (this.cal_month < 1) {
                this.cal_year = this.cal_year - 1;
                this.cal_month = 12;
            }
            this.getEvaluation();
        },

        set_cal_next: function () {
            this.cal_month = this.cal_month + 1;
            if (this.cal_month > 12) {
                this.cal_year = this.cal_year + 1;
                this.cal_month = 1;
            }
            this.getEvaluation();
        },

        btn_back: function () {
            location.href = "/classlist";
        },

        getEvaluation: function () {
            this.get_ym();

            var params = {
                classid: this.classid,
                syear: this.cal_year,
                smonth: this.cal_month,
                tmr: Date.now(),
                uidx: localStorage.getItem("uidx")
            };

            var me = this;
            this.axios.get(this.$store.state.host + "/rest/ev/getEvaluationNew_new", {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    setTimeout(function () {
                        me.eval_plan = res.data;
                        me.lang = res.data.language;

                        if (me.eval_plan.ev) {
                            setTimeout(function () {
                                me.makeChartNew();
                                // if (me.eval_plan.is_new == "Y") {
                                //     me.makeChartNew();
                                // } else {
                                //     me.makeChart();
                                // }
                            }, 100);
                        }
                    }, 100)

                } else {
                    alert(res.data.err_msg);
                }
            });
        },

        get_ym: function () {
            var mon = new Array();
            mon[0] = "1월";
            mon[1] = "2월";
            mon[2] = "3월";
            mon[3] = "4월";
            mon[4] = "5월";
            mon[5] = "6월";
            mon[6] = "7월";
            mon[7] = "8월";
            mon[8] = "9월";
            mon[9] = "10월";
            mon[10] = "11월";
            mon[11] = "12월";

            console.log(this.cal_month);
            this.cal_month_str = mon[this.cal_month - 1];

        },

        hidePop: function () {
            this.$emit('close', true);
        },

        makeChartNew: function () {
            var dat = this.eval_plan;
            dat.ev_txt = this.ev_txt;
            dat.avg = this.eval_plan.avg_report;
            if (dat.ev && dat.ev.t_comment) {
                dat.ev.t_comment = dat.ev.t_comment.replace(/\n/gi, '<br>');
            } else {
                dat.ev.t_comment = "";
            }

            var value_txt_lst = [
                "", "매우 노력 필요", "매우 노력 필요", "노력 필요", "노력 필요", "보통", "보통", "우수", "우수", "매우 뛰어남", "매우 뛰어남"
            ];
            if (this.lang == "EN") {
                dat.ev_txt.fluency_str = "Fluency";
                dat.ev_txt.accuracy_str = "Accuracy";
                dat.ev_txt.pronunciation_str = "Pronunciation";
                dat.ev_txt.comprehension_str = "Comprehension";
                dat.ev_txt.participation_str = "Participation";
                dat.ev_txt.preparation_str = "Preparation";

                value_txt_lst = [
                    "", "Need to Imporve", "Need to Imporve", "Fair", "Fair", "Good", "Good", "Very Good", "Very Good", "Excellent", "Excellent"
                ];

            } else if (this.lang == "CH") {
                dat.ev_txt.fluency_str = "流畅性";
                dat.ev_txt.accuracy_str = "准确度";
                dat.ev_txt.pronunciation_str = "发音";
                dat.ev_txt.comprehension_str = "理解度";
                dat.ev_txt.participation_str = "參與度";
                dat.ev_txt.preparation_str = "準備性";
            }
            console.log(value_txt_lst);
            let chart = am4core.create("chartdiv1", am4charts.RadarChart);
            /* Add data */
            chart.data = [{
                "field": dat.ev_txt.fluency_str,
                "ptf": dat.ev.fluency
            }, {
                "field": dat.ev_txt.accuracy_str,
                "ptf": dat.ev.accuracy,
            }, {
                "field": dat.ev_txt.pronunciation_str,
                "ptf": dat.ev.pronunciation,
            }, {
                "field": dat.ev_txt.comprehension_str,
                "ptf": dat.ev.comprehension,
            }, {
                "field": dat.ev_txt.participation_str,
                "ptf": dat.ev.participation,
            }, {
                "field": dat.ev_txt.preparation_str,
                "ptf": dat.ev.preparation
            }];

            /* Create axes */
            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "field";

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            console.log(valueAxis);
            // valueAxis.m
            valueAxis.renderer.axisFills.template.fill = chart.colors.getIndex(2);
            valueAxis.renderer.axisFills.template.fillOpacity = 0.05;
            valueAxis.min = 0;
            valueAxis.max = 10;
            let series = chart.series.push(new am4charts.RadarSeries());
            series.dataFields.valueY = "ptf";
            series.dataFields.categoryX = "field";
            series.stroke = am4core.color("#53CAFF");
            series.background.fill = am4core.color("#53CAFF");
            series.name = "Sales";
            series.strokeWidth = 2;
            // var chartopt1 = {
            //     "type": "radar",
            //     "theme": "none",
            //     "fontSize": 12,
            //     "dataProvider": [{
            //             "field": dat.ev_txt.fluency_str,
            //             "ptf": dat.ev.fluency,
            //             "color": "#989898",
            //             "text": value_txt_lst[dat.ev.fluency]
            //         },
            //         {
            //             "field": dat.ev_txt.accuracy_str,
            //             "ptf": dat.ev.accuracy,
            //             "color": "#989898",
            //             "text": value_txt_lst[dat.ev.accuracy]
            //         },
            //         {
            //             "field": dat.ev_txt.pronunciation_str,
            //             "ptf": dat.ev.pronunciation,
            //             "color": "#989898",
            //             "text": value_txt_lst[dat.ev.pronunciation]
            //         },
            //         {
            //             "field": dat.ev_txt.comprehension_str,
            //             "ptf": dat.ev.comprehension,
            //             "color": "#989898",
            //             "text": value_txt_lst[dat.ev.comprehension]
            //         }
            //     ],
            //     "valueAxes": [{
            //         "axisTitleOffset": 9,
            //         "minimum": 0,
            //         "maximum": 10,
            //         "axisAlpha": 0.50,
            //         "showLastLabel": false,
            //         "labelsEnabled": false
            //     }],
            //     "startDuration": 1,
            //     "graphs": [{
            //         "balloonText": "[[field]] : [[text]]",
            //         "bullet": "none",
            //         "lineColor": "#4cc2a5",
            //         //"bulletColor" : "#4cc2a5",
            //         "bulletBorderColor": "#4cc2a5",
            //         "fill": "#4cc2a5",
            //         "fillAlphas": 0.5,
            //         "valueField": "ptf",
            //         "lineThickness": "1.5"
            //     }],
            //     "categoryField": "field",
            //     "exportConfig": {
            //         "menuTop": "10px",
            //         "menuRight": "10px",
            //         "menuItems": [{
            //             "icon": '/resource/assets/amcharts/images/export.png',
            //             "format": 'png'
            //         }]
            //     }
            // };

            // chartopt1.dataProvider.push({
            //     "field": dat.ev_txt.participation_str,
            //     "ptf": dat.ev.participation,
            //     "color": "#989898",
            //     "text": value_txt_lst[dat.ev.participation]
            // });
            // chartopt1.dataProvider.push({
            //     "field": dat.ev_txt.preparation_str,
            //     "ptf": dat.ev.preparation,
            //     "color": "#989898",
            //     "text": value_txt_lst[dat.ev.preparation]
            // });
            // console.log(AmSerial);
            // this.chart1 = AmCharts.makeChart("chartdiv1", chartopt1);
        },

        makeChart: function () {
            var dat = this.eval_plan;
            dat.ev_txt = this.ev_txt;
            dat.avg = this.eval_plan.avg_report;
            if (dat.ev && dat.ev.t_comment) {
                dat.ev.t_comment = dat.ev.t_comment.replace(/\n/gi, '<br>');
            } else {
                dat.ev.t_comment = "";
            }

            if (this.lang == "EN") {
                dat.ev_txt.fluency_str = "Fluency";
                dat.ev_txt.accuracy_str = "Accuracy";
                dat.ev_txt.pronunciation_str = "Pronunciation";
                dat.ev_txt.comprehension_str = "Comprehension";
                dat.ev_txt.participation_str = "Participation";
                dat.ev_txt.preparation_str = "Preparation";

                } else if ( this.lang =="CH" ){
                    dat.ev_txt.fluency_str       = "流畅性";
                    dat.ev_txt.accuracy_str      = "准确度";
                    dat.ev_txt.pronunciation_str = "发音";
                    dat.ev_txt.comprehension_str = "理解度";
                    dat.ev_txt.participation_str = "參與度";
                    dat.ev_txt.preparation_str   = "準備性";
            }
            let chart = am4core.create("chartdiv1", am4charts.RadarChart);
             chart.data = [{
                "field": dat.ev_txt.fluency_str,
                "ptf": dat.ev.fluency
            }, {
                "field": dat.ev_txt.accuracy_str,
                "ptf": dat.ev.accuracy,
            }, {
                "field": dat.ev_txt.pronunciation_str,
                "ptf": dat.ev.pronunciation,
            }, {
                "field": dat.ev_txt.comprehension_str,
                "ptf": dat.ev.comprehension,
            }];

            /* Create axes */
            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "field";

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            console.log(valueAxis);
            // valueAxis.m
            valueAxis.renderer.axisFills.template.fill = chart.colors.getIndex(2);
            valueAxis.renderer.axisFills.template.fillOpacity = 0.05;
            valueAxis.min = 0;
            valueAxis.max = 10;
            let series = chart.series.push(new am4charts.ColuemSeries());
            series.dataFields.valueY = "ptf";
            series.dataFields.categoryX = "field";
            series.stroke = am4core.color("#53CAFF");
            series.background.fill = am4core.color("#53CAFF");
            series.name = "Sales";
            series.strokeWidth = 2;


            if (this.lang == "EN") {
                let chart2 = am4core.create("chartdiv2", am4charts.XYChart);
                chart2.data = [{
                    "country": dat.ev_txt.participation_str,
                    "visits": dat.ev.participation,
                },{
                    "country": dat.ev_txt.preparation_str,
                    "visits": dat.ev.preparation,
                }];
                let categoryAxis = chart2.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "country";

                let valueAxis = chart2.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.max = 10;
                let series = chart2.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = "visits";
                series.dataFields.categoryX = "country";
                series.stroke = am4core.color("#53CAFF");
                series.name = "Sales";
            }
            var chart3data = [{
                "year": dat.ev_txt.fluency_str,
                "income": dat.ev.fluency,
                "expenses": dat.avg.fluency,
            },{
                "year": dat.ev_txt.accuracy_str,
                "income": dat.ev.accuracy,
                "expenses": dat.avg.accuracy,
            },{
                "year": dat.ev_txt.pronunciation_str,
                "income": dat.ev.pronunciation,
                "expenses": dat.avg.pronunciation,
            },{
                "year": dat.ev_txt.comprehension_str,
                "income": dat.ev.comprehension,
                "expenses": dat.avg.comprehension,
            }];
            if(this.lang == "EN"){
                chart3data.push({
                    "year": dat.ev_txt.participation_str,
                    "income": dat.ev.participation,
                    "expenses": dat.avg.participation,
                });
                chart3data.push({
                        "year": dat.ev_txt.preparation_str,
                        "income": dat.ev.preparation,
                        "expenses": dat.avg.preparation,
                });
            }
            let chart3 = am4core.create("chartdiv3", am4charts.XYChart);
            let categoryAxis3 = chart3.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis3.dataFields.category = "year";
            let valueAxis3 = chart3.yAxes.push(new am4charts.ValueAxis());
            valueAxis3.min = 0;
            valueAxis3.max = 10;
            let series3 = chart3.series.push(new am4charts.ColumnSeries());
            series3.dataFields.valueY = "income";
            series3.dataFields.categoryX = "year";
            series3.stroke = am4core.color("#53CAFF");
            series3.name = "income";

            let series4 = chart3.series.push(new am4charts.LineSeries());
            series4.dataFields.valueY = "expenses";
            series4.dataFields.categoryX = "year";
            series4.stroke = am4core.color("#53CAFF");
            series4.name = "expenses";
            var nitms = [];
            for (var i in dat.reports) {
                var irow = dat.reports[i];
                var nitm = {
                    "date": irow.reportdate,
                    "Fluency": irow.fluency ? irow.fluency : "0",
                    "Accuracy": irow.accuracy ? irow.accuracy : "0",
                    "Pronunciation": irow.pronunciation ? irow.pronunciation : "0",
                    "Comprehension": irow.comprehension ? irow.comprehension : "0",
                }
                if (this.lang == "EN") {
                    nitm.Participation = irow.participation ? irow.participation : "0";
                    nitm.Preparation = irow.preparation ? irow.preparation : "0";
                }
                nitms.splice(0, 0, nitm);
                if (i == 12) break;
            }
            console.log(nitms);

                // var chart4graphs = [{
                //         "balloonText": dat.ev_txt.fluency_str + " : [[value]]",
                //         "bullet": "round",
                //         "id": "AmGraph-0",
                //         "title": dat.ev_txt.fluency_str,
                //         "valueField": "Fluency"
                //     },
                //     {
                //         "balloonText": dat.ev_txt.accuracy_str + " : [[value]]",
                //         "bullet": "round",
                //         "id": "AmGraph-1",
                //         "title": dat.ev_txt.accuracy_str,
                //         "valueField": "Accuracy"
                //     },
                //     {
                //         "balloonText": dat.ev_txt.pronunciation_str + " : [[value]]",
                //         "bullet": "round",
                //         "id": "AmGraph-2",
                //         "title": dat.ev_txt.pronunciation_str,
                //         "valueField": "Pronunciation"
                //     },
                //     {
                //         "balloonText": dat.ev_txt.comprehension_str + " : [[value]]",
                //         "bullet": "round",
                //         "id": "AmGraph-3",
                //         "title": dat.ev_txt.comprehension_str,
                //         "valueField": "Comprehension"
                //     }
                // ];
                // if (this.lang == "EN") {
                //     chart4graphs.push({
                //         "balloonText": dat.ev_txt.participation_str + " : [[value]]",
                //         "bullet": "round",
                //         "id": "AmGraph-4",
                //         "title": dat.ev_txt.participation_str,
                //         "valueField": "Participation"
                //     });
                //     chart4graphs.push({
                //         "balloonText": dat.ev_txt.preparation_str + " : [[value]]",
                //         "bullet": "round",
                //         "id": "AmGraph-5",
                //         "title": dat.ev_txt.preparation_str,
                //         "valueField": "Preparation"
                //     });
                // }
                // this.chart4 = AmCharts.makeChart("bchartdiv2", {
                //     "type": "serial",
                //     "categoryField": "date",
                //     "dataDateFormat": "YYYY-MM",
                //     "theme": "default",
                //     "categoryAxis": {
                //         "minPeriod": "MM",
                //         "parseDates": true
                //     },
                //     "chartCursor": {
                //         "categoryBalloonDateFormat": "MMM YYYY"
                //     },
                //     "pathToImages": "https://itm.carrotenglish.net/resource/assets/amcharts/images/", // required for grips
                //     "chartScrollbar": {},
                //     "trendLines": [],
                //     "graphs": chart4graphs,
                //     "guides": [],
                //     "allLabels": [],
                //     "balloon": {},
                //     "legend": {
                //         "useGraphSettings": true
                //     },
                //     "dataProvider": nitms
                // });

                this.eval_plan = dat;
        }
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.ev-wrap {
    .calendar-top {
        text-align: center;
        margin-top: 25px;

        li {
            display: inline-block;
            vertical-align: middle;
            padding: 0 10px;
        }
    }

    .none-ev {
        display: table;
        min-height: 250px;
        width: 100%;

        p {
            display: table-cell;
            vertical-align: middle;
            text-align: center;
            color: var(--unnamed-color-b7b7b7);
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0px;
            color: #B7B7B7;
            opacity: 1;
        }
    }

    .ev-info {
        width: 90%;
        margin: 0 auto;

        .ev-title-wrap {
            .ev-title {
                margin-top: 24px;
                text-align: left;
                font-size: 20px;
                letter-spacing: 0px;
                color: #53CAFF;
            }

            .ev-writer {
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                margin-top: 5px;
            }

            .ev-wdate {
                font-size: 14px;
                letter-spacing: 0px;
                color: #B7B7B7;
                margin-top: 20px;
                margin-bottom: 30px;
            }
        }

        .ev-info-wrap {
            .info-title {
                text-align: left;
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                font-weight: bold;
                padding-bottom: 10px;
                border-bottom: 1px solid #B7B7B7;
                ;

                .ico-r {
                    display: inline-block;
                    width: 17px;
                    height: 17px;
                    color: #fff;
                    background-color: #53CAFF;
                    text-align: center;
                    border-radius: 100%;
                    font-size: 14px;
                    line-height: 1;
                    font-weight: bold;
                    margin-right: 5px;
                }
            }

            .info-content {
                text-align: left;
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                word-break: break-word;
                .overall-title {
                    padding-top: 10px;
                }

                .overall-body {
                    text-align: left;
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #000000;
                    word-break: break-word;
                    ;
                }
            }

            .graph-bar-wrap {
                .graph-bar-head {
                    display: table;
                    margin-top: 15px;

                    .graph-bar-head-tit-fir {
                        width: 180px;
                        height: 30px;
                        display: table-cell;
                    }

                    .graph-bar-head-tit {
                        width: 50px;
                        height: 30px;
                        text-align: center;
                        display: table-cell;
                        vertical-align: bottom;
                        font-size: 12px;
                        color: #B7B7B7;
                        line-height: 14px;
                    }

                    .fair {
                        width: 100px;
                    }

                    .good {
                        width: 70px;
                    }

                    .very-good {
                        width: 100px;
                    }
                }

                .graph-bar-body {
                    clear: both;
                    padding-top: 10px;

                    .graph-bar-body-list {
                        clear: both;

                        .graph-bar-body-item {
                            clear: both;
                            height: 30px;
                            padding-bottom: 20px;

                            .graph-bar-tit {
                                width: 120px;
                                height: 20px;
                                font-size: 13px;
                                line-height: 20px;
                                float: left;
                                font-weight: bold;
                            }

                            .graph-bar-box {
                                width: 81px;
                                height: 15px;
                                margin-top: 3px;
                                background-color: #e6e6e6;
                                border-left: 1px solid #ffffff;
                                float: left;
                            }

                            &.col-s1 .graph-bar-box.on {
                                background-color: #9FAFFF;
                            }

                            &.col-s2 .graph-bar-box.on {
                                background-color: #92C8FF;
                            }

                            &.col-s3 .graph-bar-box.on {
                                background-color: #31B3ED;
                            }

                            &.col-s4 .graph-bar-box.on {
                                background-color: #53CAFF;
                            }

                            &.col-s5 .graph-bar-box.on {
                                background-color: #9AE0FF;
                            }
                        }
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 414px) {
    .wrap {
        width: 100%;

    }

    .class {
        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;

            &.wrap {
                width: 100%;
                padding-left: 5%;
            }

            .class-info {
                width: 90%;
            }
        }

        .tab {
            &.wrap {
                width: 100%;
            }
        }

        .writing {
            .lecture {
                margin-top: 0px;
                border-top: none;
                border-bottom: 10px solid $border-color;

                .wrap {
                    .con {
                        padding-left: 20px;
                        padding-right: 20px;
                    }
                }
            }

            table {
                width: 100%;

                th {
                    color: $gray;
                    padding: 8px 10px 0 0;
                    text-align: left;
                    width: 80px;
                }
            }
        }

        // 출결
        .calendar-wrap {
            .calendar-col {
                background: $back-gray;
                padding: 5px 0;
                font-size: 12px;

                .wrap {
                    width: 100%;
                    padding-left: 30px;
                }

                span {
                    margin-right: 5px;
                }

                .attend {
                    padding-left: 5%;
                }
            }

            .calendar {
                padding: 0px;
            }
        }

        .ev-wrap {
            .ev-info {
                .ev-info-wrap {
                    .graph-bar-wrap {
                        .graph-bar-head {
                            .graph-bar-head-tit-fir {
                                width: 160px;
                            }

                            .graph-bar-head-tit {
                                width: 60px;
                            }
                        }
                    }

                    .graph-bar-wrap {
                        .graph-bar-body {
                            .graph-bar-body-list {
                                .graph-bar-body-item {
                                    .graph-bar-box {
                                        width: 50px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 375px) {
    .class {
        .calendar-wrap {
            .calendar-col {
                .wrap {
                    padding-left: 15px;
                }
            }
        }

        .ev-wrap {
            .ev-info {
                .ev-info-wrap {
                    .graph-bar-wrap {
                        .graph-bar-head {
                            .graph-bar-head-tit-fir {
                                width: 150px;
                            }

                            .graph-bar-head-tit {
                                width: 55px;
                            }
                        }
                    }

                    .graph-bar-wrap {
                        .graph-bar-body {
                            .graph-bar-body-list {
                                .graph-bar-body-item {
                                    .graph-bar-tit {
                                        width: 110px;
                                    }

                                    .graph-bar-box {
                                        width: 41px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
